import { ContentDto } from '@cineamo/api/models/content/ContentDto.types';
import { MovieDto } from '@cineamo/api/models/movie/v2/MovieDto.types';

import { ContentListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';
import { CountryCode } from '@cineamo/api/types/CountryCode';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';

export type GetContentsQuery = {
    movieId?: MovieDto['id'];
    metricStartDatetime?: string;
    metricEndDatetime?: string;
    cinemaId?: number | string;
    showingDate?: string;
    hasMarketingAssistantBooked?: boolean;
    isMovie?: boolean;
    showingStartDateTime?: string;
    showingEndDateTime?: string;
    isShowingNow?: boolean;
    hasPremiereShowings?: boolean;
    cinemaCountryCode?: CountryCode;
} & UrlQueryParameter;

export async function getContents(query: GetContentsQuery): Promise<ApiResponse<ContentListResponse>> {
    return await apiClient
        .get(`${API_URL}/contents${buildUrlQuery(query)}`)
        .then((response) => response)
        .catch(() => null);
}

/**
 * This endpoint returns a content.
 *
 * @example
 * // Get a single content:
 * getContentById(1);
 *
 * @param id
 * @returns {ApiResponse<ContentDto>}
 */

export async function getContentById(id: string | number): Promise<ApiResponse<ContentDto>> {
    return await apiClient
        .get(`${API_URL}/contents/${id}`, {
            credentials: 'same-origin'
        })
        .then((response) => response)
        .catch(() => null);
}
